/* eslint-disable react-hooks/exhaustive-deps */
/**
 * A React functional component that imports necessary dependencies and renders the UpdateUserComponent.
 * @returns The rendered UpdateUserComponent.
 */
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getDepotsList } from "../../store/depots/actions";
import { editUser } from "../../store/usersManagement/actions";
import { useDispatch } from "react-redux";

import UpdateUserComponent from "./updateUserComponent";
import { useTranslation } from "react-i18next";
import Constant from "../../util/constant";
import { components } from "react-select";
import CustomeOptionLabel from "../../components/customeOptionLabel/customeOptionLabel";

/**
 * UpdateUsersManagement component is responsible for managing the update functionality of user management.
 * It handles form submission, user input changes, and state management for updating user data.
 * @param {{object}} props - The props object containing necessary data and functions.
 * @returns The UpdateUsersManagement component.
 */
const UpdateUsersManagement = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const selectInputRef = useRef();
  const setUpdateValue = state?.item;
  const [defaultValueSelectbox, setDefaultValueSelectbox] = useState(
    setUpdateValue?.depotname?.map((item) => {
      return {
        label: item?.depotname,
        value: item?.depotname,
        id: item?.depotid,
      };
    })
  );


  const [isupdateUserloaderButtonShow, setIsupdateUserloaderButtonShow] =
    useState(false);
  const [isMangerDepotName, setIsMangerDepotName] = useState([]);
  const [isDriverDepotName, setIsDriverDepotName] = useState("in");
  const [createUserValues, setCreateUserValues] = useState(null);
  const [depotData, setDepotData] = useState([]);
  const [phoneNumberError, setphoneNumberError] = useState("");
  const [isMobileselect, setIsMobileselect] = useState(
    setUpdateValue?.allowmobilelogin ? "yes" : "no"
  );
  const [phoneTouched, setphoneTouched] = useState(false);
  const [phoneisvalid, setphoneisvalid] = useState(false);
  const [isroleselect, setIsroleselect] = useState(setUpdateValue?.role);
  const [phoneNumbers, setPhoneNumbers] = useState(setUpdateValue?.phone);
  const [sethomeDepot, setHomeDepot] = useState(
    setUpdateValue?.homedepotid?.depotid || null
  );


  const [placeHolder, setPlaceHolder] = useState(true);
  const [fullnametextcount, setFullnametextcount] = useState(
    setUpdateValue?.fullname?.length
  );
  const [emailtextcount, setEmailtextcount] = useState(
    setUpdateValue?.emailid?.length
  );
  const [paynumbertextcount, setPaynumbertextcount] = useState(
    setUpdateValue?.payno?.length
  );
  
  useEffect(() => {
    setTimeout(() => {
      setPlaceHolder(false);
    }, 2000);
    // if (defaultValueSelectbox === null || defaultValueSelectbox?.length < 0) {
    //   setDefaultValueSelectbox(setUpdateValue?.depotname?.map((item) => {
    //     return {
    //       label: item?.depotname,
    //       value: item?.depotname,
    //       id: item?.depotid,
    //     };
    //   }))
    // }
  });

  const test = setUpdateValue?.depotname?.map((item) => {
    return {
      label: item?.depotname,
      value: item?.depotname,
      id: item?.depotid,
    };
  })

  /**
   * useEffect hook that triggers when the state's item fullname is not an empty string.
   * It sets the placeholder state to false.
   * @returns None
   */
  useEffect(() => {
    if (state?.item?.fullname !== "") {
      setPlaceHolder(false);
    }
  }, []);

  useEffect(() => {
    getDepotList();
  }, []);

  /**
   * Retrieves the list of depots and sets the depot data state.
   * @returns None
   */
  const getDepotList = () => {
    let queryParams = {};
    queryParams.status = Constant.GENERALKEYS.ACTIVE;
    dispatch(
      getDepotsList(
        queryParams,
        (res) => {
          setDepotData(
            res?.data?.map((item) => {
              return {
                ...item,
                label: item?.name,
                value: item?.name,
                id: item?.depotid,
              };
            })
          );
        },
        (err) => {
          console.log(err);
        }
      )
    );
  };

  // handle form submit

  /**
   * Handles the form submission for updating a user.
   * @param {{object}} data - The form data containing the updated user information.
   * @returns None
   */
  const handleFormSubmit = (data) => {
    setIsupdateUserloaderButtonShow(true);

    const depotDefaultId = [
      defaultValueSelectbox[0]?.id || defaultValueSelectbox?.depotid,
    ];

    if (isroleselect === Constant.GENERALKEYS.DRIVER) {
      const params = {
        fullname: data?.fullname,
        emailid: data?.email,
        payno: data?.paynumber,
        phone: data?.phone,
        role: isroleselect,
        allowmobilelogin: true,
        depotid: depotDefaultId,
        homedepotid: null,
      };
      dispatch(
        editUser(
          setUpdateValue?.userid,
          params,
          (res) => {
            navigate("/usersManagement");
            setIsupdateUserloaderButtonShow(false);
            createUserValues.reset(
              {
                fullname: "",
                email: "",
                paynumber: "",
              },
              setPhoneNumbers(""),
              setIsroleselect(""),
              setIsMobileselect(""),
              setIsDriverDepotName(""),
              setHomeDepot(""),
              setphoneTouched(false),
              setphoneNumberError(""),
              selectInputRef.current.clearValue()
            );
          },
          (err) => {
            setIsupdateUserloaderButtonShow(false);
            console.log(err);
          }
        )
      );
    } else {
      const defaultDepotId = defaultValueSelectbox?.map((item) => item?.id);
      const UpdatedDepotId = isMangerDepotName?.map((item) => item?.id);
      const params = {
        fullname: data?.fullname,
        emailid: data?.email,
        payno: data?.paynumber,
        phone: data?.phone,
        role: isroleselect,
        allowmobilelogin: isMobileselect,
        depotid:
          isMangerDepotName?.length === 0 ? defaultDepotId : UpdatedDepotId,
        homedepotid: sethomeDepot,
      };
      dispatch(
        editUser(
          setUpdateValue?.userid,
          params,
          (res) => {
            navigate("/usersManagement");
            setIsupdateUserloaderButtonShow(false);
            createUserValues.reset(
              {
                fullname: "",
                email: "",
                paynumber: "",
              },

              setPhoneNumbers(""),
              setIsroleselect(""),
              setIsMobileselect(""),
              setIsMangerDepotName(""),
              setHomeDepot(""),
              setphoneTouched(false),
              setphoneNumberError(""),
              selectInputRef.current.clearValue()
            );
          },
          (err) => {
            setIsupdateUserloaderButtonShow(false);
            console.log(err);
          }
        )
      );
    }
  };

  /**
   * Creates a user function with the given form data.
   * @param {{object}} form - The form data used to create the user.
   * @returns None
   */
  const createUserFunction = (form) => {
    setCreateUserValues(form);
  };

  /**
   * Event handler for the change event of a radio input in the Roleradio component.
   * Updates the value of the selected role and clears the value of the select input.
   * @param {{Event}} e - The event object.
   * @returns None
   */
  const roleradioChangeHandler = (e) => {
    // if (isroleselect === Constant.GENERALKEYS.DRIVER) {
    //    setHomeDepot('')
    // } 
    setDefaultValueSelectbox(null)
    setIsroleselect(e?.target?.value);
    // selectInputRef?.current?.clearValue();
  };

  /**
   * Event handler for the change event of a mobile radio button.
   * @param {{Event}} e - The event object.
   * @returns None
   */
  const mobileradioChangeHandler = (e) => {
    setIsMobileselect(e?.target?.value);
  };

  /**
   * An object representing the user form with validation rules for each field.
   * @property {{fullname: {name: string, validate: {required: {value: boolean, message: string}, pattern: {value: RegExp, message: string}, maxLength: {value: number, message: string}}}, email: {name: string, validate: {required: {value: boolean, message: string}, pattern: {value: RegExp, message: string}}}, paynumber: {name: string, validate: {required: {value: boolean, message: string}, pattern: {value: RegExp, message: string}}}}} addUserForm - The user form object.
   */

  const addUserForm = useMemo(
    () => ({
      fullname: {
        name: "fullname",
        validate: {
          required: {
            value: true,
            message: t("FULL_NAME_IS_REQUIRED"),
          },
          pattern: {
            value: Constant.REGEX.NAME,
            message: t("ALLOWED_ONLY_PERIOD_APOSTROPHE_HYPHEN_DASH_AND_SPACES"),
          },
          maxLength: {
            value: 200,
            message: t("ALLOWED_MAX_200_CHARACTERS"),
          },
        },
      },
      email: {
        name: "email",
        validate: {
          required: {
            value: true,
            message: t("EMAIL_ADDRESS_IS_REQUIRED"),
          },
          pattern: {
            value: Constant.REGEX.EMAIL,
            message: t("EMAIL_ADDRESS_IS_INVALID"),
          },
          maxLength: {
            value: 200,
          },
        },
      },
      paynumber: {
        name: "paynumber",
        validate: {
          required: {
            value: true,
            message: t("PAY_NUMBER_IS_REQUIRED"),
          },
          pattern: {
            value: Constant.REGEX.PAYNUMBER,
            message: t("ENTER_5_DIGIT_VALID_PAY_NUMBER"),
          },
          maxLength: {
            value: 5,
          },
        },
      },
      phone: {
        name: "phone",
        validate: {
          required: {
            value: true,
          },
        },
      },
      role: {
        name: "role",
        validate: {
          required: {
            value: true,
          },
        },
      },
      mobileLogin: {
        name: "mobileLogin",
        validate: {
          required: {
            value: true,
          },
        },
      },
        depot: {
          name: "depot",
          validate: {
            required: {
              value: true,
            },
          },
        },
    }),
    [phoneisvalid]
  );

  /**
   * A custom input option component for a select dropdown.
   * @param {{getStyles}} getStyles - Function to get the styles for the option.
   * @param {{Icon}} Icon - The icon component to display.
   * @param {{boolean}} isDisabled - Whether the option is disabled.
   * @param {{boolean}} isSelected - Whether the option is selected.
   * @param {{ReactNode}} children - The content of the option.
   * @param {{object}} innerProps - Additional props for the inner element.
   * @param {...rest} rest - Additional props for the component.
   * @returns The rendered input option component.
   */
  const InputOption = ({
    getStyles,
    Icon,
    isDisabled,
    isSelected,
    children,
    innerProps,
    ...rest
  }) => {
    const props = {
      ...innerProps,
    };

    return (
      <components.Option
        {...rest}
        isDisabled={isDisabled}
        isSelected={isSelected}
        getStyles={getStyles}
        innerProps={props}
      >
        <input type="checkbox" checked={isSelected} />
        <label for="checkbox">
          <span></span>
        </label>
        {children}
        {isroleselect === Constant.GENERALKEYS.DRIVER ? (
          ""
        ) : (
          <>
            {isSelected && (
              <div>
                <button
                  type="button"
                  className="sublabel"
                  onClick={(e) => {
                    e.stopPropagation();
                    setHomeDepot(rest?.data?.depotid);
                  }}
                >
                  {sethomeDepot === rest?.data?.depotid ? (
                    <>
                      <div className="HomeDepotActive">
                        <i className="mdi mdi-check"> </i>
                        <span className="sublabelText">{t("HOME_DEPOT")}</span>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="MarkDepot">
                        <i className="mdi mdi-check"> </i>
                        <span className="sublabelText">
                          {t("MARK_AS_HOME_DEPOT")}
                        </span>
                      </div>
                    </>
                  )}
                </button>
              </div>
            )}
          </>
        )}
      </components.Option>
    );
  };

  /**
   * Navigates to the "/usersManagement" page.
   * @returns None
   */
  const backPageFunction = () => {
    navigate("/usersManagement");
  };

  const handlefullnametextcount = (e) => {
    const value = e.target.value;
    setFullnametextcount(value.length);
  };

  const handleEmailtextcount = (e) => {
    const value = e.target.value;
    setEmailtextcount(value.length);
  };
  const handlePaynumbertextcount = (e) => {
    const value = e.target.value;
    setPaynumbertextcount(value.length);
  };


  return (
    <UpdateUserComponent
      innerPagetitle={t("EDIT_USER")}
      addUserForm={addUserForm}
      addUserDepotName={depotData}
      handleFormSubmit={handleFormSubmit}
      isroleselect={isroleselect}
      selectInputRef={selectInputRef}
      roleradioChangeHandler={(e) => {
        roleradioChangeHandler(e);
      }}
      isMobileselect={isroleselect === Constant.GENERALKEYS.DRIVER ? "yes" : isMobileselect}
      mobileradioChangeHandler={(e) => {
        mobileradioChangeHandler(e);
      }}
      onChangeMangerDepot={(options) => {
        if (Array.isArray(options)) {
          if (options?.length === 0) {
            setHomeDepot("");
          }
          setIsMangerDepotName(
            options.map((opt) => {
              setHomeDepot("");
              return {
                label: opt?.value,
                value: opt?.value,
                id: opt?.id || opt?.depotid,
              };
            })
          );
          setDefaultValueSelectbox(
            options.map((opt) => {
              return {
                label: opt?.value,
                value: opt?.value,
                id: opt?.id || opt?.depotid,
              };
            })
          );
        }
      }}
      isDriverDepotName={isDriverDepotName}
      onChangeDriverDepot={(options) => {
        setIsDriverDepotName(options);
        setDefaultValueSelectbox(options);
      }}
      isMangerDepotName={isMangerDepotName}
      formatOptionLabel={<CustomeOptionLabel />}
      components={{ Option: InputOption }}
      setPhoneNumbers={(e) => {
        setPhoneNumbers("+" + e);
      }}
      setphoneNumberError={setphoneNumberError}
      phoneNumberError={phoneNumberError}
      setphoneTouched={setphoneTouched}
      phoneTouched={phoneTouched}
      phoneNumbers={phoneNumbers}
      sethomeDepot={sethomeDepot}
      createUserFunction={(form) => {
        createUserFunction(form);
      }}
      placeHolderShimer={placeHolder}
      backPageFunction={backPageFunction}
      state={state}
      defaultValue={defaultValueSelectbox}
      updateUserloaderButtonShow={isupdateUserloaderButtonShow}
      fullnametextcount={fullnametextcount}
      handlefullnametextcount={handlefullnametextcount}
      emailtextcount={emailtextcount}
      handleEmailtextcount={handleEmailtextcount}
      paynumbertextcount={paynumbertextcount}
      handlePaynumbertextcount={handlePaynumbertextcount}
      setUpdateValue={setUpdateValue}
      setphoneisvalid={setphoneisvalid}
      phoneisvalid={phoneisvalid}
      test={test}
    />
  );
};

export default UpdateUsersManagement;
